import { LDObserve } from '@launchdarkly/observability';

// LDObserve.setLDContextKeyAttributes replaces the full attribute bag and
// LDObserve.getLDContextKeyAttributes returns the bag already prefixed with
// `launchdarkly.contextKeys.*`, so we can't round-trip through the SDK to
// merge. Keep the unprefixed source-of-truth locally and push a fresh union
// on each update.
const currentAttributes: Record<string, string> = {};

export function mergeLDContextKeyAttributes(attributes: Record<string, string | undefined>) {
  let changed = false;
  for (const [key, value] of Object.entries(attributes)) {
    if (value === undefined || value === '') {
      continue;
    }
    if (currentAttributes[key] === value) {
      continue;
    }
    currentAttributes[key] = value;
    changed = true;
  }
  if (changed) {
    LDObserve.setLDContextKeyAttributes({ ...currentAttributes });
  }
}
